import { render } from "./EditorContentWrapper.vue?vue&type=template&id=824b0ef2&ts=true"
import script from "./EditorContentWrapper.vue?vue&type=script&lang=ts"
export * from "./EditorContentWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__